<template>
  <v-data-table
    :headers="headers"
    :items="exchangeRates"
    class="elevation-1"
    :loading="isLoading"
  >
    <template v-slot:top>
      <v-toolbar
        flat
      >
        <v-btn
          color="success"
          data-cy="ExchangeRate-button-new"
          @click="$router.push({
            name: 'exchange-rate-EditExchangeRate'
          })"
        >
          <v-icon class="mr-2">
            {{ mdiPlus }}
          </v-icon>
          {{ $t('common.buttons.new') }}
        </v-btn>
      </v-toolbar>
    </template>
    <template v-slot:item.actions="{ item }">
      <TableBasicButtons :editLink="{
          name: 'exchange-rate-EditExchangeRate',
          query: {id: item.id}
        }"
        @delete="remove(item)"
      />
    </template>
  </v-data-table>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import { mdiPlus } from '@mdi/js';
import TableBasicButtons from '@codehq/aurora-app-core/src/components/TableBasicButtons.vue';
import loading from '@codehq/aurora-app-core/src/mixins/loading';

export default {
  name: 'ListExchangeRate',
  module: 'ExchangeRate',
  components: {
    TableBasicButtons,
  },
  mixins: [loading],
  data() {
    return {
      /**
      * Icons
      */
      mdiPlus,
    };
  },
  computed: {
    /** Vuex states
     */
    ...mapState('exchangeRates', ['exchangeRates']),
    /**
    * Get table column headers
    */
    headers() {
      return [
        {
          text: this.$$t('sourceCurrency'),
          value: 'sourceCurrency',
        },
        {
          text: this.$$t('destinationCurrency'),
          value: 'destinationCurrency',
        },
        {
          text: this.$$t('rate'),
          value: 'rate',
        },
        {
          text: '',
          value: 'actions',
        },
      ];
    },
  },
  async mounted() {
    this.isLoading = true;
    await this.LOAD_exchangeRates();
    this.isLoading = false;
  },
  methods: {
    /** Vuex methods
     */
    ...mapActions('exchangeRates', ['LOAD_exchangeRates', 'DELETE_exchangeRate']),
    /** Delete ExchangeRate from the collection
     */
    async remove(ExchangeRate) {
      this.isLoading = true;
      await this.DELETE_ExchangeRate(ExchangeRate);
      this.isLoading = false;
    },
  },
};
</script>

<docs>
# ExchangeRate example

'''js
<ExchangeRate />
'''
</docs>
